import React from 'react';
import PropTypes from 'prop-types';
import { AceCodeEditor } from '@ion/components';
import { decompressGzipString } from 'app/shared/decoders/httpResponseDecoder';

export default function ServerResponse({ integrationResponse }) {
  const value = decompressGzipString(integrationResponse);

  return <AceCodeEditor rows={30} name="server-response" readOnly lang="text" value={value} />;
}

ServerResponse.propTypes = {
  integrationResponse: PropTypes.string.isRequired,
};
